import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Zoom from 'react-medium-image-zoom';

import chromeExtension_1 from '../../../../../libraries/Images/chromeExtension_1.png';
import chromeExtension_2 from '../../../../../libraries/Images/chromeExtension_2.png';

function Vi(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="chromeextension">
                1. {translate('chromeextension')}
            </Typography>
            <p>Tiện ích mở rộng này là một chức năng cho phép bạn dễ dàng có được bộ chọn CSS bằng cách chỉ cần nhấp chuột phải vào vị trí mà bạn muốn lấy bộ chọn CSS và thực hiện [Copy CSS Selector].</p>
            <p>Quy trình:</p>
            <ol>
                <li>Chuyển đến trang cài đặt từ liên kết bên dưới.</li>
                <p>Mở <a href='https://chrome.google.com/webstore/detail/rpa-cloud/hbbknhmpmbpeahaielmdciknifcodkdj?hl=vi' target="_blank">trang cài đặt</a>.</p>
                <li>Nhấp vào [Thêm vào Chrome]</li>
                <Zoom>
                    <img src={chromeExtension_1} width="75%" />
                </Zoom>
                <li>Nhấp vào [Thêm tiện ích]</li>
                <Zoom>
                    <img src={chromeExtension_2} width="75%" />
                </Zoom>
            </ol>
        </Box>
    );
}
export default withTranslate(Vi);